// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faLogs = {
  prefix: "fak",
  iconName: "logs",
  icon: [
    640,
    512,
    [],
    "e01b",
    "M112.3 62.4L63 62.4C55.3 62.4 49 68.7 49 76.5l0 49.3c0 7.8 6.3 14.1 14.1 14.1l49.3 0c7.8 0 14.1-6.3 14.1-14.1l0-49.3c0-7.8-6.3-14.1-14.1-14.1zm388.4 0L178 62.4c-7.1 0-12.9 6.3-12.9 14.1l0 49.3c0 7.8 5.8 14.1 12.9 14.1l322.7 0c7.1 0 12.9-6.3 12.9-14.1l0-49.3c0-7.8-5.8-14.1-12.9-14.1zM112.3 217.3l-49.3 0c-7.8 0-14.1 6.3-14.1 14.1l0 49.3c0 7.8 6.3 14.1 14.1 14.1l49.3 0c7.8 0 14.1-6.3 14.1-14.1l0-49.3c0-7.8-6.3-14.1-14.1-14.1zm466.6 0l-401.6 0c-6.7 0-12.2 6.3-12.2 14.1l0 49.3c0 7.8 5.4 14.1 12.2 14.1l401.6 0c6.7 0 12.2-6.3 12.2-14.1l0-49.3c0-7.8-5.4-14.1-12.2-14.1zM112.3 372.2l-49.3 0c-7.8 0-14.1 6.3-14.1 14.1l0 49.3c0 7.8 6.3 14.1 14.1 14.1l49.3 0c7.8 0 14.1-6.3 14.1-14.1l0-49.3c0-7.8-6.3-14.1-14.1-14.1zm272.9 0l-207.9 0c-6.8 0-12.2 6.3-12.2 14.1l0 49.3c0 7.8 5.5 14.1 12.2 14.1l207.9 0c6.8 0 12.2-6.3 12.2-14.1l0-49.3c0-7.8-5.5-14.1-12.2-14.1z"
  ]
};
export {
  faLogs
};
